// Pepsi iframe for Power BI reports


import React, { useEffect, useRef } from "react";
import reportService from "./reportservice";
import PowerBIEmbeddedReport from "./power_bi_embedded_report";
import ReportEmbedManual from "./power_bi_embedded_report";
import { models, service } from "powerbi-client";
import * as pbi from "powerbi-client";
import ErrorFailOverHandler from "../../common/error_fail_over_handler";
import { set } from "date-fns";
import PBINoPermission from "../../common/pbi_no_permission";

const PowerBIReport = () => {
  const reportRef = useRef(null);
  const [embedData, setEmbedData] = React.useState(null);
  const [showErrorPage, setShowErrorPage] = React.useState(false);
  const fetchEmbedData = async () => {
    // Fetch embed details from backend (same as above)
    try {
      const response = await reportService.getReportInfo();
      if (response?.status === 'Failed') {
        console.error("Error fetching Power BI report info:", response?.errorMessage);
        setEmbedData(null);
        setShowErrorPage(true);
        return;
      }
      else {
        const url = new URL(response.embedUrl);
        const reportId = url.searchParams.get("reportId");
        setEmbedData({ ...response, reportId });
      }
    } catch (error) {
      console.error("Error fetching Power BI report info:", error);
      setShowErrorPage(true);
    }
  };

  React.useEffect(() => {
    fetchEmbedData();
  }, []);

  useEffect(() => {
    if (embedData && reportRef.current) {
      const url = new URL(embedData.embedUrl);
      const reportId = url.searchParams.get("reportId");

      const embedConfig = {
        type: "report",
        id: reportId,
        embedUrl: embedData.embedUrl,
        accessToken: embedData.token,
        tokenType: models.TokenType.Embed,
        settings: {
          panes: {
            filters: { visible: false },
            pageNavigation: { visible: true }
          }
        }
      };

      const powerbiService = new service.Service(
        pbi.factories.hpmFactory,
        pbi.factories.wpmpFactory,
        pbi.factories.routerFactory
      );

      powerbiService.embed(reportRef.current, embedConfig);
    }
  }, [embedData]);

  return (
    // <div ref={reportRef} style={{ height: "100vh", width: "100%" }} />
    <>
      {!showErrorPage ? (
        <div
          style={{
            marginLeft: "16px"
          }}
        >
          {embedData && (
            <ReportEmbedManual
              embedData={embedData}
            />
          )}
          {/* <iframe title="myIDM Reporting Portal Dashboard" width="1140" height="541.25"
          src="https://app.powerbi.com/reportEmbed?reportId=9d4a6a71-cbad-4b14-82a6-7448a0c98cfb&autoAuth=true&ctid=42cc3295-cd0e-449c-b98e-5ce5b560c1d3"
          frameborder="0" allowFullScreen="true"></iframe> */}
        </div>
      ) : (
        // <ErrorFailOverHandler
        //   header="Data not found"
        //   title="Uh oh, we can’t seem to find the data you’re looking for."
        //   supportMessage="Try going back or contact"
        //   supportLabel="Support"
        //   supportLink="mailto:DL-IAMCentralDevelopment@ips.com"
        //   alternateMessage="You can also complete tasks in myidM"
        //   alternateLabel="Go to myIDM"
        //   alternateLink="https://app.powerbi.com/home?experience=power-bi"
        //   image="src/assets/error.png"
        // />
        <PBINoPermission />
      )}
    </>


  );
};

export default PowerBIReport;




// import React from "react";
// import { PowerBIEmbed } from "powerbi-client-react";
// import { models } from "powerbi-client";

// const PowerBIReport = () => {
//   return (
//     <div
//       style={{
//         width: "calc(100% - 76px)",
//         marginLeft: "76px",
//         marginTop: "20px",
//       }}
//     >
//       <PowerBIEmbed
//         embedConfig={{
//           type: "report", // or 'dashboard'
//           id: "9d4a6a71-cbad-4b14-82a6-7448a0c98cfb", // Report ID
//           embedUrl:
//             "https://app.powerbi.com/reportEmbed?reportId=9d4a6a71-cbad-4b14-82a6-7448a0c98cfb&autoAuth=true&ctid=42cc3295-cd0e-449c-b98e-5ce5b560c1d3",
//           accessToken: "YOUR_EMBED_TOKEN", // Replace with actual token
//           tokenType: models.TokenType.Embed,
//           settings: {
//             panes: {
//               filters: { visible: false },
//               pageNavigation: { visible: true },
//             },
//             background: models.BackgroundType.Transparent,
//           },
//         }}
//         cssClassName="report-style-class"
//         getEmbeddedComponent={(embeddedReport) => {
//           // Optionally access the embedded report instance
//           console.log("Embedded Power BI Report:", embeddedReport);
//         }}
//       />
//     </div>
//   );
// };

// export default PowerBIReport;


//////////////////////////////////////////////////////////////////////////////////


// Power bi report with embeded functionality without using iframe

// import React, { useEffect, useRef, useState } from 'react';
// import * as powerbi from 'powerbi-client';
// import { models } from 'powerbi-client';

// const PowerBIReport = () => {
//     const embedContainerRef = useRef(null);
//     const [embedConfig, setEmbedConfig] = useState(null);
//     const [report, setReport] = useState(null);

//     useEffect(() => {
//         const fetchEmbedData = async () => {
//             // Fetch embed details from backend (same as above)
//             // const response = await fetch('https://app.powerbi.com/reportEmbed?reportId=e7082366-5654-41d6-920f-6c6490a507c0&autoAuth=true&ctid=42cc3295-cd0e-449c-b98e-5ce5b560c1d3');
//             // const data = await response.json();
//             // const localStorage = JSON.parse(localStorage.getItem("okta-token-storage"));
//             // const access_token= localStorage?.accessToken?.accessToken;
//             setEmbedConfig({
//                 type: 'report',
//                 id: null,
//                 embedUrl: 'https://playground.powerbi.com/en-us/sampleReportEmbed',
//                 accessToken: null,
//                 tokenType: null,
//                 settings: {
//                     panes: {
//                         filters: { expanded: false, visible: false }
//                     }
//                 }
//             });
//         };

//         fetchEmbedData();
//     }, []);

//     useEffect(() => {
//         if (embedConfig && embedContainerRef.current) {
//             const powerbiService = new powerbi.service.Service(
//                 powerbi.factories.hpmFactory,
//                 powerbi.factories.wpmpFactory,
//                 powerbi.factories.routerFactory
//             );

//             const embeddedReport = powerbiService.embed(embedContainerRef.current, embedConfig);
//             setReport(embeddedReport);

//             // Attach event listeners
//             embeddedReport.on('loaded', () => {
//                 console.log('Report loaded (raw API)');
//             });

//             embeddedReport.on('rendered', () => {
//                 console.log('Report rendered (raw API)');
//             });

//             // Clean up on component unmount
//             return () => {
//                 embeddedReport.off('loaded');
//                 embeddedReport.off('rendered');
//                 embeddedReport.reset(); // Resets the embedded component
//             };
//         }
//     }, [embedConfig]);

//     // Example of programmatic interaction
//     const applyFilter = async () => {
//         if (report) {
//             const basicFilter = {
//                 $schema: "http://powerbi.com/product/schema#basic",
//                 target: {
//                     table: "Sales",
//                     column: "Region"
//                 },
//                 operator: "In",
//                 values: ["East", "West"]
//             };
//             await report.updateFilters(powerbi.models.FiltersOperations.Add, [basicFilter]);
//             console.log('Filter applied');
//         }
//     };

//     return (
//         <div className="powerbi-container">
//             <div ref={embedContainerRef} style={{ width: '100%', height: '600px' }}>
//                 {/* Power BI report will be embedded here */}
//             </div>
//             <button onClick={applyFilter}>Apply Filter</button>
//             <iframe title="myidM Application Request Access Data Report" width="1140" height="541.25" src="https://app.powerbi.com/reportEmbed?reportId=e7082366-5654-41d6-920f-6c6490a507c0&autoAuth=true&ctid=42cc3295-cd0e-449c-b98e-5ce5b560c1d3" frameborder="0" allowFullScreen="true"></iframe>
//         </div>
//     );
// };

// export default PowerBIReport;


// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
/////////////////////////////////////////////////////////////////////////////////////////////////



// import React, { useState } from "react";
// import { models } from "powerbi-client";
// import { PowerBIEmbed } from "powerbi-client-react";

// import * as portals from "react-reverse-portal";

// // import "./DemoApp.css";

// // Root Component to demonstrate usage of wrapper component
// function PowerBIReport() {
//   const portalNode = React.useMemo(() => portals.createHtmlPortalNode(), []);
//   // PowerBI Report object (to be received via callback)
//   const [, setReport] = useState();
//   const [position, setPosition] = useState("middle");

//   // API end-point url to get embed config for a sample report
//   // const sampleReportUrl = "https://app.powerbi.com/reportEmbed?reportId=5b218778-e7a5-4d73-8187-f10824047715&groupId=f089354e-8366-4e18-aea3-4cb4a3a50b48";

//   // Report config useState hook
//   // Values for properties like embedUrl, accessToken and settings will be set on click of buttons below
//   const [sampleReportConfig, setReportConfig] = useState({
//     type: "report",
//     embedUrl: "https://app.powerbi.com/reportEmbed?reportId=281fa7ea-6d67-4c6b-a7e0-8574e77e6695&autoAuth=true&embeddedDemo=true",
//     tokenType: models.TokenType.Embed,
//     id: "9d4a6a71-cbad-4b14-82a6-7448a0c98cfb",
//     accessToken: undefined, // Set a valid token here
//     settings: {
//       panes: {
//         filters: { expanded: false, visible: false }
//       }
//     }
//   });
//   // https://app.powerbi.com/groups/9a92f451-6883-49fa-b3c7-0af3c6009c44/reports/e7082366-5654-41d6-920f-6c6490a507c0/ReportSection?experience=power-bi
//   const TopComponent = ({ position }) => {
//     return position === "top" ? <portals.OutPortal node={portalNode} /> : null;
//   };

//   const MiddleComponent = ({ position }) => {
//     return position === "middle" ? (
//       <portals.OutPortal node={portalNode} />
//     ) : null;
//   };

//   // Map of event handlers to be applied to the embedding report
//   const eventHandlersMap = new Map([
//     [
//       "loaded",
//       function () {
//         console.log("Report has loaded");
//       },
//     ],
//     [
//       "rendered",
//       function () {
//         console.log("Report has rendered");

//         // Update display message
//         setMessage("The report is rendered");
//       },
//     ],
//     [
//       "error",
//       function (event) {
//         if (event) {
//           console.error(event.detail);
//         }
//       },
//     ],
//   ]);

//   // Fetch sample report's config (eg. embedUrl and AccessToken) for embedding
//   const mockSignIn = async () => {
//     // Fetch sample report's embed config
//     // const reportConfigResponse = await fetch(sampleReportUrl);

//     // if (!reportConfigResponse.ok) {
//     //   console.error(
//     //     `Failed to fetch config for report. Status: ${reportConfigResponse.status} ${reportConfigResponse.statusText}`
//     //   );
//     //   return;
//     // }

//     // const reportConfig = await reportConfigResponse.json();
//     // console.log("Report config fetched successfully", reportConfig);
//     // // Update display message
//     // setMessage(
//     //   "The access token is successfully set. Loading the Power BI report"
//     // );

//     // // Set the fetched embedUrl and embedToken in the report config
//     // setReportConfig({
//     //   ...sampleReportConfig,
//     //   embedUrl: reportConfig.EmbedUrl,
//     //   accessToken: reportConfig.EmbedToken.Token,
//     // });
//   };

//   const changeSettings = () => {
//     // Update the state "sampleReportConfig" and re-render DemoApp component
//     setReportConfig({
//       ...sampleReportConfig,
//       settings: {
//         panes: {
//           filters: {
//             expanded: false,
//             visible: false,
//           },
//         },
//       },
//     });
//   };

//   const changeReportPosition = () => {
//     const newPosition = position === "middle" ? "top" : "middle";
//     setPosition(newPosition);
//   };

//   const [displayMessage, setMessage] = useState(
//     `The report is bootstrapped. Click the Embed Report button to set the access token`
//   );

//   const controlButtons = (
//     <div className="controls">
//       {/* <button onClick={mockSignIn}>Embed Report</button> */}

//       <button onClick={changeSettings}>Hide filter pane</button>

//       <button onClick={changeReportPosition}>Change position</button>
//     </div>
//   );

//   const header = (
//     <div className="header">
//       <div className="title">Power BI React component demo</div>
//     </div>
//   );

//   const footer = (
//     <div className="footer">
//       <div className="footer-text">
//         GitHub: &nbsp;
//         <a href="https://github.com/microsoft/PowerBI-client-react">
//           https://github.com/microsoft/PowerBI-client-react
//         </a>
//       </div>
//     </div>
//   );

//   return (
//     <div>
//       {/* <TopComponent position={position} /> */}
//       {header}
//       <portals.InPortal node={portalNode}>
//         <PowerBIEmbed
//           embedConfig={sampleReportConfig}
//           eventHandlers={eventHandlersMap}
//           cssClassName={"report-style-class"}
//           getEmbeddedComponent={(embedObject) => {
//             console.log(
//               `Embedded object of type "${embedObject.embedtype}" received!!!`
//             );
//             setReport(embedObject);
//           }}
//         />
//       </portals.InPortal>
//       {/* <MiddleComponent position={position} /> */}
//       <portals.OutPortal node={portalNode} />
//       <div className="hr"></div>

//       {/* <div className="displayMessage">{displayMessage}</div>

//       {controlButtons}

//       {footer} */}

//       {/* <div
//         style={{
//           width: "calc(100% - 76px)",
//           marginLeft: "76px",
//           marginTop: "20px",
//         }}
//       >

//         <iframe title="myIDM Reporting Portal Dashboard" width="1140" height="541.25"
//           src="https://app.powerbi.com/reportEmbed?reportId=9d4a6a71-cbad-4b14-82a6-7448a0c98cfb&autoAuth=true&ctid=42cc3295-cd0e-449c-b98e-5ce5b560c1d3"
//           frameborder="0" allowFullScreen="true"></iframe>
//       </div> */}
//     </div>
//   );
// }

// export default PowerBIReport;

